export const Report = [
    {
        'id': 'users',
        'name': 'User Report',
        'showCustomer': false, 
        'showIncompletedJobs': false,
        'showDate': false,
    },
    {
        'id': 'product-categories',
        'name': 'Product Category Report',
        'showCustomer': false, 
        'showIncompletedJobs': false,
        'showDate': false,
    },
    {
        'id': 'customers',
        'name': 'Customer Report',
        'date': 'Incompleted Job',
        'showCustomer': false, 
        'showIncompletedJobs': false,
        'showDate': true,
        'disabledDate': false,
    },
    {
        'id': 'sites',
        'name': 'Site Report',
        'showCustomer': true, 
        'showIncompletedJobs': false,
        'showDate': false,
    },
    {
        'id': 'equipments',
        'name': 'Equipment Report',
        'showCustomer': true, 
        'showIncompletedJobs': true,
        'showDate': false,
    },
    {
        'id': 'jobs',
        'name': 'Job Report',
        'date': 'Creation Date',
        'showCustomer': true, 
        'showIncompletedJobs': false,
        'showDate': true,
    },
    {
        'id': 'pms',
        'name': 'Preventive Maintenance Report',
        'date': 'Begin Date',
        'showCustomer': true, 
        'showIncompletedJobs': false,
        'showDate': true,
    },
    {
        'id': 'e-calls',
        'name': 'Emergency Call Report',
        'date': 'Date',
        'showCustomer': true, 
        'showIncompletedJobs': false,
        'showDate': true,
    },
    {
        'id': 'service-calls',
        'name': 'Service Call Report',
        'date': 'Begin Date',
        'showCustomer': true, 
        'showIncompletedJobs': false,
        'showDate': true,
    },
    {
        'id': 'services',
        'name': 'All Details Report',
        'date': 'Begin Date',
        'showCustomer': true, 
        'showIncompletedJobs': false,
        'showDate': true,
    },
    {
        'id': 'survey',
        'name': 'Survey Report',
        'date': 'Completion date',
        'showCustomer': true, 
        'showIncompletedJobs': false,
        'showDate': true,
    },
];


export const ReportNormalUserRole = [
    {
        'id': 'services',
        'name': 'All Details Report',
        'date': 'Begin Date',
        'showCustomer': true, 
        'showIncompletedJobs': false,
        'showDate': true,
    }
];



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/report/report.ts